import { render } from "./device-details-configuration.vue?vue&type=template&id=4ed81cfd&scoped=true&ts=true"
import script from "./device-details-configuration.ts?vue&type=script&lang=ts"
export * from "./device-details-configuration.ts?vue&type=script&lang=ts"

import "./device-details-configuration.scss?vue&type=style&index=0&id=4ed81cfd&scoped=true&lang=scss"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ed81cfd"]])

export default __exports__